import { CircularProgress } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import ActionTable from "../../components/table/ActionTable";
import api from "../../services/api";
import AppContext from "../../container/context";
import { mergeParams } from "../../helpers/helpers";
import Form from "../../components/form";

export default function Lista({ history, location }) {
  const [carregando, setCarregando] = useState(false);
  const [dados, setDados] = useState(
    mergeParams({ nome: "", exibirInativos: false }, location)
  );
  const [lista, setLista] = useState([]);
  const { notification } = useContext(AppContext);

  useEffect(() => {
    carregarProdutos();
  }, []);

  const carregarProdutos = (filtrosEnviar = dados) => {
    setDados(filtrosEnviar);

    setCarregando(true);
    api
      .get("produtosPerto/listar", filtrosEnviar)
      .then((res) => {
        setLista(res);
        setCarregando(false);
      })
      .catch((err) => {
        notification("error", "Não foi possível listar os produtos");
        setCarregando(false);
      });
  };

  const abrirProduto = (registro) => {
    history.push(`/app/produto-perto/${registro.id}`);
  };

  const tRegistros = {
    title: "Produtos Perto",
    onLineClick: abrirProduto,
    newItemAction: () => history.push("/app/produto-perto/0"),
    columns: [
      {
        name: "nome",
        label: "Nome",
      },
    ],
    array: lista,
  };

  const filtros = {
    title: "Filtros",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 8,
        value: dados.nome,
      },
      exibirInativos: {
        label: "Exibir inativos",
        type: "check",
        space: 4,
        value: dados.exibirInativos,
      },
    },

    submit: {
      label: "Buscar",
      action: carregarProdutos,
    },

    urlParams: true,
    history,
    location,
  };

  return (
    <div>
      <Form formData={filtros} />
      <br />
      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
